var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "banner",
      style: {
        "background-color": "" + _vm.backgroundColor,
        "background-image": "url(" + _vm.backgroundImage + ")"
      }
    },
    [
      _vm._t("default", [
        _c("div", {
          staticClass: "banner__title",
          domProps: { innerHTML: _vm._s(_vm.title) }
        }),
        _vm._v(" "),
        _vm.displayBannerLine
          ? _c("hr", { staticClass: "banner__line" })
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "banner__tagline",
          domProps: { innerHTML: _vm._s(_vm.tagline) }
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }